export enum ActionType {
  Comment = 'Comment',
  AppointmentNote = 'AppointmentNote',
}

export enum ActionStatus {
  Undefined = 'Undefined',
  Active = 'Active',
  Archived = 'Archived',
}

export enum EntityType {
  Member = 'Member',
  Appointment = 'Appointment',
}

export interface ActionResponseBody {
  id: string;
  type: ActionType;
  status: ActionStatus;
  entityType: EntityType;
  entityId: string;
  createdBy: string;
  creatorName: string;
  createdAt: Date;
  updatedBy: string;
  updatedAt: Date;
  archivedBy: string;
  archivedAt: Date;
  scheduleDate: Date;
  content: string;
  metadata: unknown;
}

export interface ActionCommentRequestBody {
  type: ActionType;
  entityType: EntityType;
  entityId: string;
  content: string;
  metadata?: unknown;
}
